import { CheckCircle, Loader2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export type AddToStashtPillState = "idle" | "saving" | "success";

export interface AddToStashtPillProps {
  state: AddToStashtPillState;
  label: string;
  className?: string;
  disabled?: boolean;
  /** Smaller padding for thumbnail overlays */
  compact?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export function AddToStashtPill({
  state,
  label,
  className,
  disabled = false,
  compact = false,
  onClick,
}: AddToStashtPillProps) {
  const content =
    state === "saving" ? (
      <>
        <Loader2 className="h-3 w-3 animate-spin" />
        Adding
      </>
    ) : state === "success" ? (
      <>
        <CheckCircle className="h-3 w-3" />
        Added
      </>
    ) : (
      label
    );

  const isDisabled = disabled || state === "saving" || state === "success";

  return (
    <Button
      type="button"
      size="xs"
      variant={state === "success" ? "default" : "add-to-stasht"}
      onClick={onClick}
      disabled={isDisabled}
      className={cn(
        // Ensure we never render a real border; the visual "border" is the inset ring.
        // Needed because some Button sizes include a border width class.
        "border-0",
        // Don't fade processing/disabled states; keep the pill fully opaque.
        "disabled:opacity-100",
        compact && "text-ui-caption px-2 py-1",
        state === "success" && "bg-positive text-positive-foreground disabled:bg-positive disabled:text-positive-foreground border-0",
        className,
      )}
    >
      {content}
    </Button>
  );
}

